var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorOutlineOutlined, CheckOutlined } from '@mui/icons-material';
import { Loading } from '../../assets';
import LoadingSpinner from './Layout/LoadingSpinner';
export var getActionIcon = function (variant, loading) {
    if (loading) {
        return (_jsx(LoadingSpinner, __assign({ spin: true }, { children: _jsx(Loading, {}) })));
    }
    switch (variant) {
        case 'error':
        case 'incomplete': {
            return _jsx(ErrorOutlineOutlined, {});
        }
        case 'success': {
            return _jsx(CheckOutlined, {});
        }
        default: {
            return undefined;
        }
    }
};
